import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { LoggingService } from '../../shared/services/logging/logging.service';
import { filter, map, takeWhile, tap } from 'rxjs/operators';
import { combineLatest, Observable, ReplaySubject } from 'rxjs';
import { Logo } from '../store/logo.model';
import * as logoReducer from '../store/logo.reducer';
import * as logoActions from '../store/logo.actions';
import * as fromCommon from '../../shared';
import * as fromShared from '../../shared';

@Component({
    selector: 'ef-logo-feature',
    templateUrl: './logo-feature.component.html',
    styleUrls: ['./logo-feature.component.scss'],
    standalone: false
})
export class LogoFeatureComponent implements OnInit, OnDestroy {
    process$: Observable<fromShared.Process>;
    selectedError$: Observable<fromShared.Errors.IShowErrors>;
    selectedErrorWithStatus$: Observable<fromCommon.IStatusMessage>;
    SaveLogo = new ReplaySubject<Logo>(1);
    public logo$: Observable<Logo>;
    active = true;
    ShowErrorSubject = new ReplaySubject<fromShared.Errors.IShowErrors>(1);
    constructor(
        private log: LoggingService,
        private store: Store<logoReducer.State>
    ) {}

    ngOnInit() {
        this.store.dispatch(logoActions.getLogo({ UploadType: 'Web Logo' }));
        this.setupObservables();
    }

    ngOnDestroy() {
        this.active = false;
    }

    setupObservables() {
        this.process$ = this.store.pipe(select(fromShared.selectCurrent));
        this.logo$ = this.store.pipe(
            select(logoReducer.selectAll),
            map(x => x[0])
        );

        this.selectedError$ = this.store.pipe(
            select(fromShared.Errors.getShowErrors),
            tap(selected =>
                this.log.verbose({
                    type: 'LogoFeatureComponent:selectedError$',
                    selected
                })
            )
        );
        const errors$ = this.store.pipe(select(fromShared.Errors.getErrors));
        this.selectedErrorWithStatus$ = combineLatest([
            this.selectedError$,
            errors$,
            this.logo$.pipe(filter(x => !!x))
        ]).pipe(
            tap(([selected, errors]) =>
                this.log.verbose({
                    type: 'LogoFeatureComponent:errors$',
                    errors,
                    selected
                })
            ),
            map(
                ([selected, errors]) =>
                    errors.filter(
                        e =>
                            e.MsgEntityID === selected.MsgEntityID &&
                            e.MsgProcessID === selected.MsgProcessID
                    )[0]
            ),
            tap(selected =>
                this.log.verbose({
                    type: 'LogoFeatureComponent:errors$:filtered',
                    selected
                })
            )
        );
    }

    setupSubscriptions() {
        combineLatest([this.process$, this.ShowErrorSubject])
            .pipe(takeWhile(() => this.active))
            .subscribe(([process, event]) => {
                this.store.dispatch(
                    new fromShared.Errors.SetShowErrors({
                        open: event.open,
                        MsgEntityID: event.MsgEntityID,
                        MsgProcessID: process.ProcessID
                    })
                );
            });
    }

    onSaveLogo($event) {
        const logo: Logo = {
            Uploadfile: $event,
            Uploadtype: 'Web Logo'
        };
        this.store.dispatch(
            logoActions.putLogo({
                logo
            })
        );
    }
    onShowError(event) {
        this.ShowErrorSubject.next(event);
    }
}
